export default __webpack_public_path__ + "static/media/Step5.50620893.png";